import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getOldUIRoutes } from '../../../routes'
import { Report, TUser } from '../../../types/commonTypes'
import styles from './ReportsPreview.module.css'
import { ReportsTabs } from './ReportsTabs'
import { ReportsDataProvider } from '../../../contexts/ReportsContextProvider'
import { ReportType } from '../../../contexts/ReportsContextHelper'
import { OrganizationReport } from './OrganizationReport'
import { InstructorReport } from './InstructorReport'
import { SponsoredReport } from './SponsoredReport'
import { PlayerReport } from './PlayerReport'

type ReportsPreviewProps = {
  user: TUser
}

const getSelectedReportUrl = (selectedReport: Report, user: TUser): ReportType | string => {
  //NOTE Leaving the legacy codes here in case there comes a neeed to go back to the legacy reports
  const useNewReports = true //user?.allowedOptions.includes(AllowedOption['UX3_REPORTING'])

  if (useNewReports) {
    switch (selectedReport) {
      case Report.BUSINESS:
        return ReportType.ORG
      case Report.GROUP:
        return getOldUIRoutes.businessGroupReporting()
      case Report.PLAYER:
        return ReportType.PLAYER
      case Report.SPONSORED_GAMES:
        return ReportType.SPONSORED
      case Report.TEACHER:
        return ReportType.INSTRUCTOR
    }
  } else {
    switch (selectedReport) {
      case Report.BUSINESS:
        return getOldUIRoutes.businessReporting(user.businessReportUrl)
      case Report.GROUP:
        return getOldUIRoutes.businessGroupReporting()
      case Report.PLAYER:
        return getOldUIRoutes.playerReporting()
      case Report.SPONSORED_GAMES:
        return getOldUIRoutes.sponsoredGamesReporting()
      case Report.TEACHER:
        return getOldUIRoutes.teacherReporting()
    }
  }
}

export const ReportsPreview: React.FC<ReportsPreviewProps> = ({ user }) => {
  const { t } = useTranslation()
  const { reports } = user
  const [selectedReport, setSelectedReport] = useState<Report>(user.reports[0])
  const selectedReportTypeOrUrl = getSelectedReportUrl(selectedReport, user)

  return (
    <div className={styles.mainContainer}>
      <ReportsTabs allowedReports={reports} selectedReport={selectedReport} onSelectReport={setSelectedReport} />
      <div className={styles.reportsView}>
        {selectedReportTypeOrUrl === ReportType.ORG && (
          <ReportsDataProvider reportType={selectedReportTypeOrUrl}>
            <OrganizationReport />
          </ReportsDataProvider>
        )}
        {selectedReportTypeOrUrl === ReportType.INSTRUCTOR && (
          <ReportsDataProvider reportType={selectedReportTypeOrUrl}>
            <InstructorReport />
          </ReportsDataProvider>
        )}
        {selectedReportTypeOrUrl === ReportType.SPONSORED && (
          <ReportsDataProvider reportType={selectedReportTypeOrUrl}>
            <SponsoredReport />
          </ReportsDataProvider>
        )}
        {selectedReportTypeOrUrl === ReportType.PLAYER && (
          <ReportsDataProvider reportType={selectedReportTypeOrUrl}>
            <PlayerReport />
          </ReportsDataProvider>
        )}
        {typeof selectedReportTypeOrUrl === 'string' && (
          <>
            <a className={styles.reportLink} href={selectedReportTypeOrUrl} target='_blank' rel='noreferrer'>
              {t('reports_page.view_in_new_tab_link', 'View report in new tab')}
            </a>
            <iframe title='Reports view' src={selectedReportTypeOrUrl} className={styles.reportContainer} />
          </>
        )}
      </div>
    </div>
  )
}
